export default __webpack_public_path__ + "static/media/Mark-2-Suit-10.101a4fe6.jpg";